import Vue from 'vue'

import ElementUI from 'element-ui'
// import VCharts from 'v-charts'

import './theme/coocaa-red/index.css'
// import 'element-ui/lib/theme-chalk/index.css'

import './bus'

import AppState from '@william17/vue-app-state'

import '@ccprivate/admin-toolkit/dist/admin-toolkit.css'
import { GateSchemaForm, Table, ContentCard, DataForm, String, Enum, Any, Boolean } from '@ccprivate/admin-toolkit'
import pagination from './components/pagination.vue'
import TimeFormat from './components/TimeFormat.vue'
import ContentBox from '@/components/common/ContentBox.vue'
import MediaView from '@/components/media/MediaView.vue'

import '@/assets/icon/iconfont.css'

import consts from '@/utils/consts'
import { cloneDeep } from 'lodash'

import AdminBase from '@ccprivate/admin-base'
import moment from 'moment'

Vue.use(AdminBase)
Vue.prototype.$consts = consts
Vue.prototype.$moment = moment

Vue.prototype.cloneDeep = cloneDeep
Vue.component('pagination', pagination)
Vue.component('TimeFormat', TimeFormat)
// Vue.use(VCharts)
Vue.use(ElementUI)
Vue.prototype.$ELEMENT = { size: 'medium', zIndex: 3000 }
Vue.use(AppState)
Vue.component('Table', Table)
Vue.component('GateSchemaForm', GateSchemaForm)
Vue.component('ContentCard', ContentCard)
Vue.component('DataForm', DataForm)
Vue.component('FormString', String)
Vue.component('FormEnum', Enum)
Vue.component('FormAny', Any)
Vue.component('FormBoolean', Boolean)
Vue.component('ContentBox', ContentBox)
Vue.component('MediaView', MediaView)

Vue.directive('noSpace', {
  bind: function (el, binding, vnode) {
    const vm = vnode.componentInstance
    el.addEventListener('keydown', (e) => {
      if (e.keyCode === 32) {
        e.preventDefault()
      }
    })
    el.addEventListener('paste', (e) => {
      let paste = (event.clipboardData || window.clipboardData).getData('text')
      if (paste.indexOf(' ') !== -1) {
        e.preventDefault()
        paste = paste.replace(/\s/g, '')
        vm.$emit('input', paste)
      }
    })
  }
})
Vue.directive('noEmoji', {
  inserted: function (el, binding, vnode) {
    // 聚焦元素
    const vm = vnode.componentInstance
    el.addEventListener('change', function () {
      // 进行验证
      checkedfun(el)
    })
    function checkedfun(el) {
      let value = el.__vue__.value
      // eslint-disable-next-line
      value = value.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\·\~\！\@\#\¥\%\……\&\*\（\）\——\-\+\=\【\】\{\}\、\|\；\‘\’\：\“\”\《\》\？\，\。\、\`\~\!\#\$\%\^\&\*\(\)\_\[\]{\}\\\|\;\'\'\:\"\"\,\.\/\<\>\?\+\$]/g, '')
      vm.$emit('input', value)
    }
  }
})
// 权限指令
Vue.directive('permission', function (el, binding, vNode) {
  let value = binding.value
  let display = el.style.display
  if (value instanceof Array) {
    value = value[0]
    display = value[1]
  }
  if (vNode.context.$appState.$get('permissions') && vNode.context.$appState.$get('permissions')[value] === undefined && value !== 'permission') {
    el.style.display = 'none'
  } else {
    el.style.display = display
  }
})
